import FreshlyMulchedGardenImage from "../../images/tasks/freshly-mulched-garden.jpeg";

export const mulchCalendar = [
  {
    name: "Mulch",
    description:
      "Mulch is a layer of material applied to the surface of soil. Reasons for applying mulch include conservation of soil moisture, improving fertility and health of the soil, reducing weed growth and enhancing the visual appeal of the area.",
    learn: "https://www.youtube.com/watch?v=1Yb2x3b3n6o",
    frequency: "Bi-annual",
    bestMonths: ["February", "August"],
    otherMonths: "all",
    image: FreshlyMulchedGardenImage,
  },
];
